import { gql } from '@apollo/client'

export const STORE_REFERRAL_CODE = gql`
  mutation StoreReferralCode($input: ReferralCodeInput!) {
    referral {
      storeReferralCode(input: $input) {
        success
      }
    }
  }
`
